export class BillingDiscrepancyRequestReason {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default BillingDiscrepancyRequestReason;